



































import Component from 'vue-class-component';
import { Prop, Vue } from 'vue-property-decorator';
import HuntingTicketFull = Orders.HuntingTicketFull;

@Component({
  name: 'HuntingTicket',
})
export default class HuntingTicket extends Vue {
  @Prop({ required: true, type: Object })
  ticket!: HuntingTicketFull;
}
